import { render, staticRenderFns } from "./MultiCheckbox.vue?vue&type=template&id=6cbba0b2&scoped=true&"
import script from "./MultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./MultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MultiCheckbox.vue?vue&type=style&index=0&id=6cbba0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbba0b2",
  null
  
)

export default component.exports